import * as React from 'react';
import styled from '@emotion/styled';
import { observer } from 'src/utils/mobx-react';

const SvgElement = styled('svg', { label: 'SvgElement' })`
    height: auto;
`;

interface PropsType {
    className?: string;
    onClick?: () => void;
}

export const StarBrandIcon = observer(
    'StarBrandIcon',
    ({ className, onClick }: PropsType): JSX.Element => (
        <SvgElement
            className={className}
            onClick={onClick}
            fill='none'
            width='32'
            height='32'
            viewBox='0 0 32 32'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M16 25.252L25.8875 31.413L23.272 19.7913L32 11.9769L20.4937 10.9564L16 0L11.5055 10.9564L0 11.9769L8.72808 19.7913L6.11176 31.413L16 25.252Z'
                fill='#FDC500'
            />
        </SvgElement>
    )
);
